export interface Coordinates {
  name: string;
  href: string;
  coordinate: string;
}
